export default "/img/CZ.bb724f168bf8dd2d17837648be860ddb.png";